export default {
      id: "logoTRS--footer-usage",
      viewBox: "0 0 91 45",
      url: __webpack_public_path__ + "img/icons.cd84ca0f.svg#logoTRS--footer",
      toString: function () {
        return this.url;
      }
    }